import { getRecoil, setRecoil } from "recoil-nexus";
import roomState from "../../atoms/room";
import { socket } from "../index";

const listenReceiveResponseJoinRoom = () => {
  socket?.on('RECEIVE_RESPONSE_JOIN_ROOM', () => {
    const room = getRecoil(roomState);
    setRecoil(roomState, {
      ...room,
      isJoin: true,
    });
  });
}

export default listenReceiveResponseJoinRoom;